export default "__VITE_ASSET__DYUrCuVh__"